module.exports = __webpack_public_path__ + "static/media/pres87.afc62abb.png";